import { API_BASE } from "../services/api"; // comment lại
import React, { useState } from "react";

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Sai tên đăng nhập hoặc mật khẩu");
        setLoading(false);
        return;
      }

      // Lưu token và user vào localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      // Gọi hàm từ App để cập nhật trạng thái
      onLogin(data.user);
    } catch (error) {
      setError("Không thể kết nối đến máy chủ. Vui lòng thử lại sau.");
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "80px auto",
        padding: "30px 24px",
        background: "#ffffff",
        borderRadius: 16,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        border: "1px solid #e9edf2",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: 8,
          color: "#1e3a5f",
          fontWeight: 700,
        }}
      >
        🏠 Quản gia
      </h2>
      <p
        style={{
          textAlign: "center",
          marginBottom: 24,
          color: "#64748b",
          fontSize: 14,
        }}
      >
        Đăng nhập để tiếp tục
      </p>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Tên đăng nhập"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{
            width: "100%",
            padding: "10px 14px",
            marginBottom: 12,
            border: "1px solid #d1d5db",
            borderRadius: 8,
            fontSize: 14,
            boxSizing: "border-box",
          }}
          required
        />
        <input
          type="password"
          placeholder="Mật khẩu"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            padding: "10px 14px",
            marginBottom: 16,
            border: "1px solid #d1d5db",
            borderRadius: 8,
            fontSize: 14,
            boxSizing: "border-box",
          }}
          required
        />

        {error && (
          <div
            style={{
              marginBottom: 12,
              padding: "8px 12px",
              background: "#fee2e2",
              borderRadius: 6,
              color: "#dc2626",
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "12px",
            background: loading ? "#94a3b8" : "#1e3a5f",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: loading ? "not-allowed" : "pointer",
            transition: "background 0.2s",
          }}
        >
          {loading ? "Đang đăng nhập..." : "Đăng nhập"}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
